var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewsletter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 94 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9009 55.7376V80.3496C17.9009 80.3496 17.8956 83.7123 21.8756 83.7123C25.2196 83.7123 25.1063 80.3496 25.1063 80.3496V55.7376V54.0563H12.5503C12.5503 54.0563 2.61426 53.2923 2.61426 38.3109C2.61426 24.4003 13.3156 24.4283 13.3156 24.4283H42.0529V54.0563H36.3983",
    stroke: "currentColor",
    strokeWidth: 4.75867,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0537 24.4281C42.0537 24.4281 47.6337 22.4868 54.5897 15.8401C61.4684 9.26675 63.9137 3.15208 63.9137 3.15208V73.0121",
    stroke: "currentColor",
    strokeWidth: 4.75867,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0537 54.0561C42.0537 54.0561 47.7697 55.2761 54.7257 61.9228C61.6044 68.4948 63.9137 73.0121 63.9137 73.0121",
    stroke: "currentColor",
    strokeWidth: 4.75867,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9834 23.4827C64.9834 23.4827 72.9327 29.0094 72.9327 39.2414C72.9327 49.4734 64.9834 54.056 64.9834 54.056",
    stroke: "currentColor",
    strokeWidth: 4.75867,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4463 28.7103H90.949",
    stroke: "currentColor",
    strokeWidth: 4.75867,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4463 38.5448H90.949",
    stroke: "currentColor",
    strokeWidth: 4.75867,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4463 48.379H90.949",
    stroke: "currentColor",
    strokeWidth: 4.75867,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsletter);
export default __webpack_public_path__ + "static/media/newsletter.68d93f6c7633ef6cfbefed04cd52c885.svg";
export { ForwardRef as ReactComponent };